import { render } from "./LanguageToggle.vue?vue&type=template&id=03fdded4&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=03fdded4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fdded4"]])

export default __exports__